/**
 * @file src/core/contextLoss.js
 * Xử lý webglcontextlost / webglcontextrestored.
 *
 * Vì sao BẮT BUỘC: Chrome giới hạn ~16 WebGL context/process. Khi front-end mở
 * nhiều iframe và vượt trần, trình duyệt CHỦ ĐỘNG hủy context cũ nhất → bài đang
 * mở bị màn hình đen "không rõ lý do". Mã lỗi CONTEXT_LOST là cách FE biết để
 * hiện "Đang khôi phục…" thay vì màn hình lỗi đỏ.
 */

/**
 * @param {HTMLCanvasElement} canvas
 * @param {{ onLost: () => void, onRestored: () => void }} handlers
 * @returns {() => void} hàm gỡ listener
 */
export function watchContextLoss(canvas, handlers) {
  /** @param {Event} e */
  const onLost = (e) => {
    // BẮT BUỘC preventDefault, nếu không trình duyệt sẽ KHÔNG bao giờ gửi restored
    e.preventDefault();
    console.warn('[webgl] context LOST');
    handlers.onLost();
  };
  const onRestored = () => {
    console.warn('[webgl] context RESTORED');
    handlers.onRestored();
  };

  canvas.addEventListener('webglcontextlost', onLost, false);
  canvas.addEventListener('webglcontextrestored', onRestored, false);

  return () => {
    canvas.removeEventListener('webglcontextlost', onLost);
    canvas.removeEventListener('webglcontextrestored', onRestored);
  };
}
